module.exports = __webpack_public_path__ + "img/falling_stars.27ebf732.gif";